import {
  GET_CONTINGENCY_EXPENSE,
  GET_CONTINGENCY_EXPENSE_ERROR,
  GET_CONTINGENCY_EXPENSE_SUCCESS
} from './ContingencyExpenseSection.actions'

const initialState = {
  contingencyExpense: {},
  error: null,
  loading: false
}

/**
 * contingenciesTradedAmounts's reducer.
 */
const contingenciesTradedAmounts = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_CONTINGENCY_EXPENSE: {
      return { ...state, loading: true }
    }
    case GET_CONTINGENCY_EXPENSE_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_CONTINGENCY_EXPENSE_SUCCESS: {
      return { ...state, contingencyExpense: payload.contingencyExpense, loading: false }
    }
    default: {
      return state
    }
  }
}

export default contingenciesTradedAmounts
